import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import HeaderButtons from './header';
import Filters from './filters';
// import Button from 'common/components/elements/buttons/primary';
import './style.scss'
import Icon from 'common/components/elements/icons';
import VideoCard from 'common/components/modules/video-card';
import CircleLoader from 'common/components/elements/loader/circle';
import PageLoader from 'common/components/modules/page-loading';

import EmptyState from 'common/components/modules/empty-states';
// import NoMoreResults from 'common/components/modules/no-more-results';
import cx from 'classnames';
import ReorderingContent, { SortableItem } from 'admin/views/reorder-content';
import { createPortal } from 'react-dom';
import { CopyContentLink } from 'admin/utils/CopyContentLink';
import classNames from 'classnames';
// import PinLabel from 'common/components/modules/pin-label';

const LiveStreamList = ({
   isMobile,
   goTo,
   initData,
   recordedStreams,
   filters,
   resources,
   emptyFilters,
   onFilterChange,
   onClearAllFilters,
   isFetchingRecordFilter,
   isNewFetchingRecords,
   isEmptyByFilterRecord,
   hasAccess,
   onSendAccessRequest,
   openDeleteConfirmModal,
   isEmptyByRecord,
   isFetchingRecord,
   onTipModalClose,
   onClickSetId,
   siteUrl,
   countesState,
   downloadOriginalFile,
   isDownloading,
   screenWidth,
   isReorderMode,
   setReorderMode,
   onSortEnd,
   onClickPreview,
   pinRecordedStream,
   isInsideModal,
   selections,
   showNewStyles,
   onSelectThisVideo,
   contentType,
   bundleId,
   isDemoMode,
   checkAndUnlockDemoPublicSite,
   preventAutoSelect = false,
   showOnlyList = false,
}) => {
   const { data } = recordedStreams;
   const emptyRecoreds = isEmptyByRecord;
   const endList = recordedStreams && recordedStreams.current_page === recordedStreams.last_page;
   const [filterType, setFilterType] = useState('');
   const desktopType = isMobile ? 'mobile' : 'desktop';
   const [draggableItem, setDraggableItem] = useState(null)
   const [checkedItems, setCheckedItems] = useState([])
   const [checkedItemsIds, setCheckedItemsIds] = useState([])

   useEffect(() => {
      if(isInsideModal && !preventAutoSelect) {
         onSelectThisVideo(checkedItems)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [checkedItems]);

   useEffect(() => {
      if(isInsideModal && selections?.length) {
         setCheckedItems([...selections])
         let ids = selections.map(item => item?.id)
         setCheckedItemsIds([...ids])
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const onShare = (id, pagename) => {
      checkAndUnlockDemoPublicSite(() => {
         CopyContentLink(siteUrl, id, pagename);
      })
   }

   const view = (
      <div
         className={ cx({
            'pb-6': (isInsideModal ||  ['store', 'chat', 'related_content'].includes(contentType)) && screenWidth < 1025,
         }) }
      >
         <Filters
            filters={ filters }
            resources={ resources }
            desktopType={ isMobile ? 'mobile' : 'desctop' }
            emptyFilters={ emptyFilters }
            onFilterChange={ (value, name, type) => {
               onFilterChange(value, name);
               setFilterType(type);
            } }
            onClearAllFilters={ (type) => {
               onClearAllFilters();
               setFilterType(type);
            }  }
            hasAccess={ hasAccess }
            countesState={ countesState }
            screenWidth={ screenWidth }
            isReorderMode={ isReorderMode }
            contentType={ contentType }
            isInsideModal={ isInsideModal }
         />
      </div>
   )

   return (
      <div
         className={ classNames({
            'flex flex-col w-full livestream-index-page relative': true,
            'min-h-full': endList && !showOnlyList,
            'min-h-[101%]': !endList && !showOnlyList && !isNewFetchingRecords,
            'h-full': showOnlyList,
         }) }
      >
         {
            !isInsideModal && !showOnlyList &&
            <HeaderButtons
               goTo={ goTo }
               date={ initData?.scheduled_date }
               isMobile={ isMobile }
               hasAccess={ hasAccess }
               isOnline={ initData?.is_online }
               countesState={ countesState }
               screenWidth={ screenWidth }
               isReorderMode={ isReorderMode }
               setReorderMode={ setReorderMode }
               onClickPreview={ onClickPreview }
            />
         }
         {
            !isMobile && !isInsideModal && !showOnlyList && (
               <span className='page-title font-bold text-major mx-5 mb-6'>Recorded streams</span>
            )
         }
         {
            isFetchingRecord && (
               <div className={ cx({
                  'flex flex-1 h-full items-center justify-center live-stream-non-access': true,
               }) }>
                  <PageLoader withLoader={ isInsideModal } customStyle={ isInsideModal } />
               </div>
            )
         }
         {
            !isFetchingRecord &&  (
               <>
                  {
                     !showOnlyList && (
                        ['store', 'chat', 'related_content'].includes(contentType) && screenWidth > 1024 && !!document.getElementById('recorded_streams-filter-content') ?
                           createPortal(
                              view
                              ,
                              document.getElementById('recorded_streams-filter-content')
                           )
                           : view
                     )
                  }
                  {
                     !hasAccess && (
                        <div className='flex flex-1 h-full items-center justify-center live-stream-non-access'>
                           <EmptyState
                              noContentText={ `If you would like your livestream turned on, please \n request access via live chat.` }
                              icon='online-stream'
                              buttonText='Request access'
                              className='h-full'
                              onAdd={ onSendAccessRequest }
                              mainButtonIcon={ null }
                           />
                        </div>
                     )
                  }
                  {
                     !!hasAccess && (
                        <>
                           {
                              emptyRecoreds && (
                                 <div className='flex flex-col justify-center items-center empty-stream my-auto'>
                                    <div className='w-8 h-8 flex items-center justify-center mb-6'>
                                       <Icon
                                          name='online-stream'
                                          size='2xl'
                                          color='placeholder'
                                       />
                                    </div>
                                    <span className='leading-tight text-base text-center text-placeholder'> You don’t have any recorded streams</span>
                                 </div>
                              )
                           }
                           {
                              !emptyRecoreds && (
                                 <>
                                    <ReorderingContent
                                       contentType='recorded_streams'
                                       onSortEnd={ onSortEnd }
                                       setDraggableItem={ (value) => {
                                          setDraggableItem(value)
                                       } }
                                       data={ data }
                                       isInsideModal={ isInsideModal }
                                       screenWidth={ screenWidth }
                                       wrapperClassName={ showOnlyList ? '!px-0' : '' }
                                    >
                                       {
                                          !isFetchingRecordFilter && data && data.map((item, index) => {
                                             let tooltiptext = ''
                                             if(item.is_future_publish_enabled) {
                                                tooltiptext = 'scheduled'
                                             } else if(!item.is_future_publish_enabled && !item.is_published) {
                                                tooltiptext = 'unpublished'
                                             }
                                             if(isReorderMode && (item?.is_pinned || (!item.is_future_publish_enabled && !item.is_published) || (item.is_future_publish_enabled))) {
                                                return null
                                             }

                                             let disabledCardForSelect = isInsideModal ? contentType === 'store' && item?.already_added_to_bundle_id !== null && item?.already_added_to_bundle_id !== bundleId : isReorderMode && !data?.is_published

                                             return (
                                                <SortableItem
                                                   key={ item.id }
                                                   className='relative'
                                                   index={ index }
                                                   id={ item.id }
                                                   isRotate={ draggableItem === index }
                                                   type='videos'
                                                   isReorderMode={ isReorderMode }
                                                   disabled={ !item?.is_published }
                                                   disabledState={ isReorderMode && !item?.is_published }
                                                   tooltiptext={ tooltiptext }
                                                >
                                                   <div
                                                      className={
                                                         cx({
                                                            '!rotate-2 overflow-hidden bg-transparent': draggableItem === index,
                                                         })
                                                      }
                                                      key={ item && item.id }
                                                   >
                                                      {/* {
                                                         item.is_pinned && (
                                                            <PinLabel margin={ 4 } className='z-40 left-2 top-4' />
                                                         )
                                                      } */}
                                                      <VideoCard
                                                         downloadOriginalFile={ downloadOriginalFile }
                                                         data={ item }
                                                         openDeleteConfirmModal={ () => openDeleteConfirmModal(item.id) }
                                                         isDownloading={ isDownloading }
                                                         streamAccess={ item.stream_access ? item.stream_access[item.who_can_stream] : {} }
                                                         onClickDetailsLink={ () => {} }
                                                         routeName='RECORDED_VIDEO'
                                                         points={ !isInsideModal }
                                                         desktopType={ desktopType }
                                                         type='livestream'
                                                         isProgress={ !item.completed }
                                                         hasLivestreamError={ !!item.has_livestream_error }
                                                         onClickOpenTips={ onTipModalClose }
                                                         onClickSetId={ onClickSetId }
                                                         siteUrl={ siteUrl }
                                                         disabled={ disabledCardForSelect }
                                                         pinVideo={ (id, bool) => pinRecordedStream(id, Boolean(bool)) }
                                                         isPinned={ item?.is_pinned }
                                                         isInsideModal={ isInsideModal }
                                                         showCheckboxes={ isInsideModal }
                                                         showNewStyles={ showNewStyles }
                                                         selectedItemsIds={ checkedItemsIds }
                                                         onSelectThisVideo={ async () => {
                                                            if(checkedItemsIds.includes(item.id)) {
                                                               setCheckedItems(prev => prev.filter(it => it.id !== item.id))
                                                               setCheckedItemsIds(prev => prev.filter(id => id !== item.id))
                                                            } else {
                                                               setCheckedItems([...checkedItems, item])
                                                               setCheckedItemsIds([...checkedItemsIds, item.id])
                                                            }

                                                            if(preventAutoSelect){
                                                               onSelectThisVideo(item)
                                                            }

                                                         } }
                                                         isDemoMode={ isDemoMode }
                                                         originalContentStorageSettingsRoute='MY_SITE_CONTENT_STORAGE'
                                                         onShare={ (pagename) => onShare(item.id, pagename) }
                                                         isReorderMode={ isReorderMode }
                                                      />
                                                   </div>
                                                </SortableItem>

                                             )
                                          })
                                       }
                                    </ReorderingContent>
                                    {
                                       (isFetchingRecordFilter || isNewFetchingRecords) && (
                                          <div
                                             className={ cx({
                                                'flex w-full justify-center items-center': true,
                                                'h-20': isNewFetchingRecords,
                                                'flex-1': isFetchingRecordFilter,
                                             }) }
                                          >
                                             <CircleLoader />
                                          </div>
                                       )
                                    }

                                    {
                                       isEmptyByFilterRecord && !isFetchingRecordFilter && !isNewFetchingRecords && (
                                          <div
                                             // style={ isEmptyByFilterRecord ? { minHeight: 'calc(100vh - 320px)' } : {} }
                                             className='flex items-center w-full my-auto'>
                                             <EmptyState
                                                type={ filterType === 'filter' ? 'filter' : 'search' }
                                                result={  filterType }
                                             />
                                          </div>
                                       )
                                    }
                                    {/* {
                                       !isFetchingRecordFilter && !isEmptyByFilterRecord && endList && (
                                          <NoMoreResults className='pb-10 no_results mt-4 flex-1' />
                                       )
                                    } */}
                                 </>
                              )
                           }

                        </>
                     )
                  }
               </>
            )
         }
      </div>
   );
};

LiveStreamList.propTypes = {
   isMobile: PropTypes.bool,
   goTo: PropTypes.func,
   initData: PropTypes.object,
   recordedStreams: PropTypes.object,
   isFetchingRecordFilter: PropTypes.bool,
   isFetchingRecord: PropTypes.bool,
   resources: PropTypes.object,
   filters: PropTypes.object,
   emptyFilters: PropTypes.bool,
   onClearAllFilters: PropTypes.func,
   onFilterChange: PropTypes.func,
   isEmptyByFilterRecord: PropTypes.bool,
   isNewFetchingRecords: PropTypes.bool,
   hasAccess: PropTypes.bool,
   onSendAccessRequest: PropTypes.func,
   onTipModalClose: PropTypes.func,
   onClickSetId: PropTypes.func,
   downloadOriginalFile: PropTypes.func,
   openDeleteConfirmModal: PropTypes.func,
   isEmptyByRecord: PropTypes.bool,
   isDownloading: PropTypes.bool,
   countesState: PropTypes.object,
   siteUrl: PropTypes.string,
   screenWidth: PropTypes.number,
   isReorderMode: PropTypes.bool,
   setReorderMode: PropTypes.func,
   onSortEnd: PropTypes.func,
   onClickPreview: PropTypes.func,
   pinRecordedStream: PropTypes.func,
   isInsideModal: PropTypes.bool,
   showNewStyles: PropTypes.bool,
   selections: PropTypes.array,
   onSelectThisVideo: PropTypes.func,
   contentType: PropTypes.string,
   bundleId: PropTypes.any,
   isDemoMode: PropTypes.bool,
   checkAndUnlockDemoPublicSite: PropTypes.func,
   preventAutoSelect: PropTypes.bool,
   showOnlyList: PropTypes.bool,
};

LiveStreamList.defaultProps = {
   isInsideModal: false,
   showNewStyles: false,
   contentType: '',
   bundleId: null,
   isDemoMode: false,
}

export default React.memo(LiveStreamList);
